<template>
  <div id="creatLeadInfoContainer">
    <b-form @submit="onSubmit">
      <b-form-group label="中文姓名" label-for="input-1">
        <b-form-input id="input-1" v-model="form.name" required placeholder="Enter Name"></b-form-input>
      </b-form-group>
      <b-form-group label="E - mail" label-for="input-6">
        <b-form-input v-model="form.email" disabled="disabled" id="input-6"></b-form-input>
      </b-form-group>
      <b-form-group label="手機" label-for="input-7">
        <b-form-input v-model="form.cellPhone" disabled="disabled" id="input-7"></b-form-input>
      </b-form-group>
      <b-form-group label="性別" label-for="radio-group-1">
        <b-form-radio-group id="radio-group-1" v-model="form.sex" :options="sexs"></b-form-radio-group>
      </b-form-group>
      <b-form-group label="品牌別" label-for="input-3">
        <b-form-select
          id="input-3"
          v-model="form.brand"
          :options="brands"
          v-on:change="setMediaAndAgeRangeOptions"
          required
        ></b-form-select>
      </b-form-group>
      <b-form-group label="年齡區間" label-for="input-2">
        <b-form-select id="input-2" v-model="form.ageRange" :options="ageRanges" required></b-form-select>
      </b-form-group>
      <b-form-group label="名單管道" label-for="input-4">
        <b-form-select id="input-4" v-model="form.leadSource" :options="leadSources" required></b-form-select>
      </b-form-group>
      <b-form-group label="媒體三層" label-for="input-5">
        <b-form-select
          id="input-5"
          v-model="form.media"
          :options="medias"
          v-on:change="setMediaItemOptions"
          required
        ></b-form-select>
        <b-form-select
          v-model="form.mediaItem"
          :options="mediaItems"
          v-on:change="setMarketMediaOptions"
          required
        ></b-form-select>
        <b-form-select v-model="form.marketMedia" :options="marketMedias" required></b-form-select>
      </b-form-group>
      <b-form-group style="text-align:center;">
        <b-button type="submit" variant="danger">確定</b-button>
      </b-form-group>
    </b-form>
  </div>
</template>

<script>
import { LeadHandler } from "@/handler/LeadHandler.js";
import { Loading } from "element-ui";
import store from "@/vuex/store_lead.js";
export default {
  props: ["tutorChatToken"],
  data() {
    return {
      form: {
        name: "",
        email: "",
        cellPhone: "",
        sex: "1",
        ageRange: null,
        brand: 1,
        leadSource: null,
        media: null,
        mediaItem: null,
        marketMedia: null
      },
      ageRanges: [{ text: "請選擇品牌別", value: null }],
      brands: [
        { text: "TutorABC", value: 1 },
        { text: "tutorJr", value: 33 }
      ],
      sexs: [
        { text: "男", value: "1" },
        { text: "女", value: "2" }
      ],
      leadSources: [],
      medias: [{ text: "請選擇品牌別", value: null }],
      mediaItems: [{ text: "請選擇", value: null }],
      marketMedias: [{ text: "請選擇", value: null }]
    };
  },
  created() {
    let loadingInstance = Loading.service({ fullscreen: true });
    this.form.email = store.state.checkLeadInfo.email;
    this.form.cellPhone = store.state.checkLeadInfo.cellPhone;
    this.setInitialOptions();
    loadingInstance.close();
  },
  methods: {
    setInitialOptions: function() {
      var getLeadSourceResult = LeadHandler.getLeadSourceOptions(
        this.form.brand,
        this.tutorChatToken
      );
      this.leadSources = getLeadSourceResult.Options;
      this.form.leadSource = getLeadSourceResult.DefaultValue;

      this.ageRanges = LeadHandler.getAgeRangeOptions(
        this.form.brand,
        this.tutorChatToken
      );
      this.form.ageRange = null;

      var getMediaResult = LeadHandler.getMediaOptions(
        this.form.brand,
        this.tutorChatToken
      );
      this.medias = getMediaResult.Options;
      this.form.media = getMediaResult.DefaultValue;

      var getMediaItemResult = LeadHandler.getMediaItemOptions(
        this.form.brand,
        this.form.media,
        this.tutorChatToken
      );
      this.mediaItems = getMediaItemResult.Options;
      this.form.mediaItem = getMediaItemResult.DefaultValue;

      var getMarketMediaResult = LeadHandler.getMarketMediaOptions(
        this.form.brand,
        this.form.mediaItem,
        this.tutorChatToken
      );
      this.marketMedias = getMarketMediaResult.Options;
      this.form.marketMedia = getMarketMediaResult.DefaultValue;
    },
    //選擇了品牌之後會帶出該品牌的預設的名單管道、媒體三層與年齡區間
    setMediaAndAgeRangeOptions: function() {
      let loadingInstance = Loading.service({ fullscreen: true });
      this.setInitialOptions();
      loadingInstance.close();
    },
    setMediaItemOptions: function() {
      if (this.form.media == null) {
        return;
      }
      let loadingInstance = Loading.service({ fullscreen: true });
      this.marketMedias = [{ text: "請選擇", value: null }];
      this.form.marketMedia = null;
      this.mediaItems = LeadHandler.getMediaItemOptions(
        this.form.brand,
        this.form.media,
        this.tutorChatToken
      ).Options;
      this.form.mediaItem = null;
      loadingInstance.close();
    },
    setMarketMediaOptions: function() {
      if (this.form.mediaItem == null) {
        return;
      }
      let loadingInstance = Loading.service({ fullscreen: true });
      this.marketMedias = LeadHandler.getMarketMediaOptions(
        this.form.brand,
        this.form.mediaItem,
        this.tutorChatToken
      ).Options;
      this.form.marketMedia = null;
      loadingInstance.close();
    },
    onSubmit(evt) {
      evt.preventDefault();
      let loadingInstance = Loading.service({ fullscreen: true });
      var createLeadSn = LeadHandler.createLead(this.form, this.tutorChatToken);
      loadingInstance.close();
      store.dispatch("setDisplayToDefult");

      window.location.href =
        "#/MobileLeadInfoView?ls=" +
        createLeadSn;
    }
  }
};
</script>

<style scoped>
.form-group {
  margin-bottom: 5px;
}
#creatLeadInfoContainer {
  height: calc(100vh - 5px);
  overflow: auto;
  background: #fff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  font-size: 13px;
  padding: 10px 15px;
}
.btn {
  font-size: 15px;
  background: #b20404;
}
.custom-select:focus {
  box-shadow: none;
  border-color: #ced4da;
}
.form-control,
.custom-select {
  font-size: 14px;
}

input.form-control,
.custom-select {
  margin-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/Main/CreateLead.vue